module.exports = __webpack_public_path__ + "media/images/flags/4x3/prt-645059c5a7c00d6b2c9650e42b40fe44.svg";